module.exports = __webpack_public_path__ + "img/image_default.f8239c94.svg";